(ns minorodata.components.snacks.core
  (:require [re-posh.core :as re-posh]
            [minorodata.app.handlers :refer [dispatch]]
            [ui.toast]))


(defn close-snack [id]
  (fn [_ reason]
    (when-not (= reason "clickaway")
      (dispatch [:app.events/close-snack id]))))


(defn stack []
  (let [snacks @(re-posh/subscribe [:snack/pull-many])
        active-snacks (->> snacks
                           (filter :snack/active)
                          ;; db ids are generally only incrementing, so this is
                          ;; a good replacement for timestamp sorting
                           (sort-by :db/id)
                           reverse)

       ;; Showing only one message at a time. This will not
       ;; pollute the screen with all the error messages at
       ;; once and will also dismiss the messages one by one
       ;; automatically.
        visible-snacks (take 1 active-snacks)
        on-close-all (when (> (count active-snacks) 1)
                       (fn []
                         (doseq [snack active-snacks]
                           (dispatch [:app.events/close-snack (:db/id snack)]))))]

    [ui.toast/toast-container
     (doall
      (for [snack visible-snacks
            :let [{:snack/keys [active type message metadata]} snack

                  id       (:db/id snack)
                  on-close (close-snack id)
                  data-cy  (:data-cy metadata)]]
        ^{:key id}
        [ui.toast/toast
         {:id id
          :active true
          :title (:title metadata)
          :message message
          :type type
          :metadata metadata
          :active-snacks-count (count active-snacks)
          :on-close on-close
          :on-close-all on-close-all
          :data-cy data-cy}]))]))
